import { type ReactNode } from 'react'
import { Head, Link } from '@inertiajs/react'
import AdminLayout from '@/components/AdminLayout'
import ResearchNav from '@/components/admin/research/ResearchNav'
import ResearchEventForm from '@/components/admin/research/ResearchEventForm'
import { Button } from '@/components/ui/button'
import { ArrowLeft } from 'lucide-react'
import type {
  ResearchCustomFieldDef,
  ResearchEventDetail,
  ResearchSuggestions,
  ResearchVenueOption,
} from '@/types/research'

type Props = {
  event: ResearchEventDetail
  organizations: { id: string; name: string }[]
  venues: ResearchVenueOption[]
  sponsor_names: string[]
  industries: string[]
  suggestions: ResearchSuggestions
  causes: string[]
  custom_fields: ResearchCustomFieldDef[]
}

export default function ResearchEventEdit({
  event,
  organizations,
  venues,
  sponsor_names,
  industries,
  suggestions,
  causes,
  custom_fields,
}: Props) {
  return (
    <>
      <Head title={`Research - ${event.name || 'Event'}`} />
      <div>
        <h1 className="text-3xl font-semibold tracking-tight font-serif">Research Database</h1>
        <div className="mt-4">
          <ResearchNav />
        </div>
        <Button asChild variant="ghost" size="sm" className="-ml-2 mb-3">
          <Link href={`/admin/research/events/${event.id}`}>
            <ArrowLeft className="mr-1 size-4" />
            Back to event
          </Link>
        </Button>
        <h2 className="mb-6 text-2xl font-semibold tracking-tight">
          Edit {event.name || 'Research Entry'}
        </h2>
        <div className="max-w-4xl">
          <ResearchEventForm
            event={event}
            organizations={organizations}
            venues={venues}
            sponsorNames={sponsor_names}
            industries={industries}
            suggestions={suggestions}
            causes={causes}
            customFields={custom_fields}
          />
        </div>
      </div>
    </>
  )
}

ResearchEventEdit.layout = (page: ReactNode) => <AdminLayout>{page}</AdminLayout>
